import { propOr } from 'ramda'

export default errors =>
  Object.keys(errors).map(key => {
    return `${key} - ${propOr('', key, errors)}`
  })
